var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Button, Dimmer, Form, Grid, Loader, Message, Modal, Segment } from "semantic-ui-react";
import { InvalidCartItem, is4xx, ValidCartItem } from "./CartPage";
import { ORIGIN } from "./Config";
import ErrorDisplay from "./ErrorDisplay";
import ChromogenKitForm from "./kit/automated-pro/ChromogenKitForm";
import AutomatedProEditKitForm from "./kit/automated-pro/EditKitForm";
import EditCommentModal from "./kit/EditCommentModal";
import { buildEditFormStateHandlerForComponent } from "./kit/FormState";
import KitIndexHeader from "./kit/KitIndexHeader";
import { EditKitForm as ManualGoldIfKitForm, serializeManualGoldIfKit } from "./kit/manual-gold-if/EditKitForm";
import ManualProConsumerKitForm from "./kit/manual-pro/ManualProConsumerKitForm";
import EditKitForm, { CART_PRICE_PATH } from "./kit/rna-fish/EditKitForm";
import KitDisplay, { isNegativeControlManualPro, isNegativeControlRnaFish } from "./kit/rna-fish/KitDisplay";
import { AutomatedGoldIfKit, AutomatedGoldIfPricedKit, AutomatedProKit, ManualGoldIfKit, ManualGoldIfPricedKit, ManualProKit, PricedManualProKit, RnaFishKit, RnaFishPricedKit } from "./kit/rna-fish/KitModel";
import { ErrorElements, kitPriceToGoogleAnalyticsItems } from "./kit/rna-fish/NewRnaFishKitPage";
import { EditKitForm as SecondaryIfEditKitForm, serializeSecondaryIfKit } from "./kit/secondary-if/EditKitForm";
import { ProKitConfig } from "./KitDeserializer";
import { deleteWithAuthn, postJsonWithAuthn } from "./RequestHelpers";
var CartItemView = /** @class */ (function (_super) {
    __extends(CartItemView, _super);
    function CartItemView(props) {
        var _this = _super.call(this, props) || this;
        _this.setRnaFishFormState = buildEditFormStateHandlerForComponent('rnaFishFormState', _this);
        _this.setSecondaryIfFormState = buildEditFormStateHandlerForComponent('secondaryIfFormState', _this);
        _this.setRnaCishFormState = buildEditFormStateHandlerForComponent('rnaCishFormState', _this);
        _this.setEncoderFormState = buildEditFormStateHandlerForComponent('encoderFormState', _this);
        _this.setChromogenKitFormState = buildEditFormStateHandlerForComponent('chromogenKitFormState', _this);
        _this.setManualProFormState = buildEditFormStateHandlerForComponent('manualProKitFormState', _this);
        _this.deleteButton = function (item) {
            var onDeleteClick = function () { return _this.deleteItem(item); };
            return React.createElement(Modal, { closeIcon: true, open: _this.state.deleteModalOpen, size: 'large', onClose: _this.onCancel, trigger: React.createElement(Button, { "aria-label": 'Remove kit', basic: true, className: 'cart-item-remove-button', icon: 'trash', onClick: _this.onDeleteModalOpenClick, title: 'Remove kit' }) },
                React.createElement(Modal.Header, null, "Confirm Action"),
                React.createElement(Modal.Content, null,
                    React.createElement(Dimmer, { active: _this.state.editItemLoading, inverted: true },
                        React.createElement(Loader, null)),
                    React.createElement("p", null, "Are you sure you want to delete?"),
                    React.createElement(Button, { icon: 'trash', label: "Remove kit", labelPosition: 'left', negative: true, onClick: onDeleteClick })));
        };
        _this.editComment = function (item) {
            var button = React.createElement(Button, { onClick: _this.onCommentModalOpenClick, icon: 'edit', label: item.kit.comment.length === 0 ? 'Add Comment' : 'Edit Comment', labelPosition: "left" });
            var onSaveClick = function () { return _this.onSave(item); };
            var formNode = React.createElement(EditCommentModal, { kitPriceUrlPath: CART_PRICE_PATH, fishFormState: _this.state.rnaFishFormState, ishFormState: _this.state.rnaCishFormState, chromogenFormState: _this.state.chromogenKitFormState, encoderFormState: _this.state.encoderFormState, secondaryIfFormState: _this.state.secondaryIfFormState, manualProFormState: _this.state.manualProKitFormState, setFishFormState: _this.setRnaFishFormState, setIshFormState: _this.setRnaCishFormState, setChromogenFormState: _this.setChromogenKitFormState, setEncoderFormState: _this.setEncoderFormState, setSecondaryIfFormState: _this.setSecondaryIfFormState, setManualProFormState: _this.setManualProFormState, initialComment: item.kit.comment });
            var handleKeyDown = function (e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    onSaveClick();
                }
            };
            return React.createElement(Modal, { onKeyDown: handleKeyDown, closeIcon: true, open: _this.state.editCommentOpen, 
                // size={'large'}
                onClose: _this.onCancel, trigger: button },
                React.createElement(Modal.Header, null, item.kit.comment.length === 0 ? 'Add Comment' : 'Edit Comment'),
                React.createElement(Modal.Content, null,
                    React.createElement(Dimmer.Dimmable, { as: Form, error: _this.state.errors.length > 0 || _this.state.rnaFishFormState.errors.length > 0 },
                        React.createElement(Dimmer, { active: _this.state.editItemLoading, inverted: true },
                            React.createElement(Loader, null)),
                        formNode,
                        React.createElement("br", null),
                        React.createElement(ErrorDisplay
                        // error display for when updating fails
                        , { 
                            // error display for when updating fails
                            errors: _this.state.errors, errorPath: "/contents/" + item.id }),
                        React.createElement("div", { style: { 'textAlign': 'right' } },
                            React.createElement(Button, { icon: 'cancel', label: 'Cancel', labelPosition: 'left', onClick: _this.onCancel }),
                            React.createElement(Button, { icon: 'save', label: 'Save', className: ORIGIN === "hcr" ? "cish-button" : "", labelPosition: 'left', onClick: onSaveClick, positive: true })))));
        };
        // Starter kit cards render through StarterKitCartCard, so this only appears on normal cart items.
        _this.quantityStepper = function (item) {
            var onDecrement = function () {
                if (item.quantity <= 1) {
                    // dropping below 1 removes the line -- go through the same confirmation as Remove kit
                    _this.setState({ deleteModalOpen: true });
                }
                else {
                    _this.updateQuantity(item, item.quantity - 1);
                }
            };
            var onIncrement = function () { return _this.updateQuantity(item, item.quantity + 1); };
            return React.createElement(Button.Group, { className: 'cart-item-quantity-stepper' },
                React.createElement(Button, { className: 'cart-item-quantity-stepper-button', icon: 'minus', onClick: onDecrement, disabled: _this.state.editItemLoading, "aria-label": 'Decrease quantity', title: 'Decrease quantity' }),
                React.createElement(Button, { basic: true, className: 'cart-item-quantity-stepper-value', content: "" + item.quantity }),
                React.createElement(Button, { className: 'cart-item-quantity-stepper-button', icon: 'plus', onClick: onIncrement, disabled: _this.state.editItemLoading, "aria-label": 'Increase quantity', title: 'Increase quantity' }));
        };
        _this.updateQuantity = function (item, quantity) {
            _this.props.setParentLoadingState(true);
            var path = "/cart/item/id/" + encodeURIComponent(item.id) + "/quantity";
            _this.setState({
                editItemLoading: true
            }, function () {
                postJsonWithAuthn(path, JSON.stringify({ quantity: quantity }))
                    .then(function (resp) {
                    if (is4xx(resp.status)) {
                        return resp.json().then(function (json) {
                            return new ErrorElements(json.errors);
                        });
                    }
                    return resp.json();
                })
                    .then(function (json) {
                    if (json instanceof ErrorElements) {
                        _this.setState({
                            errors: json.errors,
                            editItemLoading: false
                        }, function () {
                            _this.props.setParentLoadingState(false);
                        });
                    }
                    else {
                        _this.props.onCartChange(json);
                        _this.setState({
                            errors: [],
                            editItemLoading: false
                        });
                        _this.props.setParentLoadingState(false);
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't update quantity: " + rej);
                });
            });
        };
        _this.negativeControlProbe = function (pricedKit) {
            if (pricedKit instanceof RnaFishPricedKit) {
                return isNegativeControlRnaFish(pricedKit.kit);
            }
            else if (pricedKit instanceof PricedManualProKit) {
                var probeSet = pricedKit.kit.probeSet;
                var amp = pricedKit.kit.detect;
                var chromogen = pricedKit.kit.chromogen;
                var manualBuffer = pricedKit.kit.buffers;
                return (probeSet !== undefined) &&
                    probeSet.scale.scaleValue === 50 &&
                    !amp &&
                    !chromogen &&
                    !manualBuffer &&
                    isNegativeControlManualPro(probeSet);
            }
            else {
                return false;
            }
        };
        _this.editModal = function (item) {
            var trigger = React.createElement(Button, { "aria-label": 'Edit kit', basic: true, className: 'cart-item-edit-button', icon: 'cog', onClick: _this.onModalOpenClick, title: 'Edit kit' });
            var onSaveClick = function () { return _this.onSave(item); };
            var kitPriceUrlPath = CART_PRICE_PATH;
            // TODO this is ugly
            var formNode;
            if (item.pricedKit instanceof RnaFishPricedKit) {
                formNode = React.createElement(EditKitForm, { kitPriceUrlPath: kitPriceUrlPath, catalog: _this.props.catalog.rnaCatalog, formState: _this.state.rnaFishFormState, loadPriceOnMount: true, restrictCustomTargetProbeSetSizeToCatalog: true, enableCustomPrice: false, enableNegativeControlProbe: false, enableAmplifierCustomScale: false, enableProbeSetCustomScale: false, enableBufferCustomScale: false, enableAdminSystems: false, setFormState: _this.setRnaFishFormState, legacy: item.pricedKit.kit.legacy, showErrors: true });
            }
            else if (_this.automatedProKitCheck(item.pricedKit.kit)) {
                formNode = React.createElement("div", { className: 'consumer-edit-enzymatic-ish-form' },
                    React.createElement(AutomatedProEditKitForm, { kitPriceUrlPath: kitPriceUrlPath, catalog: _this.props.catalog.rnaCatalog, formState: _this.state.rnaCishFormState, setFormState: _this.setRnaCishFormState, kitConfigurations: [ProKitConfig.ProbeDetect, ProKitConfig.ProbeOnly, ProKitConfig.DetectOnly], loadPriceOnMount: true }));
            }
            else if (_this.proChromogenOnlyKitCheck(item.pricedKit.kit)) {
                formNode = React.createElement("div", { className: 'consumer-edit-enzymatic-ish-form' },
                    React.createElement(ChromogenKitForm, { kitPriceUrlPath: kitPriceUrlPath, catalog: _this.props.catalog.rnaCatalog, formState: _this.state.chromogenKitFormState, setFormState: _this.setChromogenKitFormState, loadPriceOnMount: true }));
            }
            else if (item.pricedKit instanceof PricedManualProKit) {
                formNode = React.createElement(ManualProConsumerKitForm, { kitPriceUrlPath: kitPriceUrlPath, catalog: _this.props.catalog.rnaCatalog, formState: _this.state.manualProKitFormState, loadPriceOnMount: true, restrictCustomTargetProbeSetSizeToCatalog: true, enableNegativeControlProbe: false, enableCustomPrice: false, enableAmplifierCustomScale: false, enableProbeSetCustomScale: false, enableBufferCustomScale: false, setFormState: _this.setManualProFormState, showErrors: true });
            }
            else if (item.pricedKit instanceof ManualGoldIfPricedKit) {
                formNode = React.createElement(ManualGoldIfKitForm, { kitPriceUrlPath: kitPriceUrlPath, catalog: _this.props.catalog.secondaryIfCatalog, formState: _this.state.encoderFormState, loadPriceOnMount: true, setFormState: _this.setEncoderFormState, enableCustomPrice: false, enableAdminSystems: false, showErrors: true });
            }
            else if (item.pricedKit instanceof AutomatedGoldIfPricedKit) {
                // TODO
            }
            else {
                formNode = React.createElement(SecondaryIfEditKitForm, { kitPriceUrlPath: kitPriceUrlPath, catalog: _this.props.catalog.secondaryIfCatalog, formState: _this.state.secondaryIfFormState, loadPriceOnMount: true, setFormState: _this.setSecondaryIfFormState, legacy: item.pricedKit.kit.legacy, enableCustomPrice: false, showErrors: true });
            }
            return React.createElement(Modal, { closeIcon: true, open: _this.state.editModalOpen, size: 'large', onClose: _this.onCancel, trigger: trigger },
                React.createElement(Modal.Header, null, "Edit kit"),
                React.createElement(Modal.Content, null,
                    React.createElement(Dimmer.Dimmable, { as: Form, error: _this.state.errors.length > 0 || _this.state.rnaFishFormState.errors.length > 0 },
                        React.createElement(Dimmer, { active: _this.state.editItemLoading, inverted: true },
                            React.createElement(Loader, null)),
                        formNode,
                        React.createElement(ErrorDisplay
                        // error display for when updating fails
                        , { 
                            // error display for when updating fails
                            errors: _this.state.errors, errorPath: "/contents/" + item.id }),
                        React.createElement("div", { style: { 'textAlign': 'right' } },
                            React.createElement(Button, { icon: 'cancel', label: 'Cancel', labelPosition: 'left', onClick: _this.onCancel }),
                            React.createElement(Button, { icon: 'save', label: 'Save', labelPosition: 'left', onClick: onSaveClick, className: ORIGIN === "hcr" ? "cish-button" : "", positive: true })))));
        };
        _this.onModalOpenClick = function () {
            _this.setState({
                editModalOpen: true,
                rnaFishFormState: _this.props.initialRnaFishEditFormState,
                secondaryIfFormState: _this.props.initialSecondaryIfEditFormState,
                rnaCishFormState: _this.props.initialRnaCishFormState,
                manualProKitFormState: _this.props.initialManualProFormState
            });
        };
        _this.onCommentModalOpenClick = function () {
            _this.setState({
                editCommentOpen: true
            });
        };
        _this.onDeleteModalOpenClick = function () {
            _this.setState({
                deleteModalOpen: true
            });
        };
        _this.onCancel = function () {
            _this.setState({
                editModalOpen: false,
                editCommentOpen: false,
                deleteModalOpen: false,
                errors: [],
                rnaFishFormState: _this.props.initialRnaFishEditFormState,
                secondaryIfFormState: _this.props.initialSecondaryIfEditFormState,
                rnaCishFormState: _this.props.initialRnaCishFormState,
                manualProKitFormState: _this.props.initialManualProFormState
            });
        };
        _this.onSave = function (item) {
            var path = "/cart/item/id/" + encodeURIComponent(item.id);
            _this.setState({
                editItemLoading: true
            }, function () {
                var body;
                if (item.pricedKit.kit instanceof RnaFishKit) {
                    body = EditKitForm.serializeRnaFishKit(_this.state.rnaFishFormState);
                }
                else if (_this.automatedProKitCheck(item.pricedKit.kit)) {
                    body = AutomatedProEditKitForm.serializeMultiPlexProKit(_this.state.rnaCishFormState);
                }
                else if (_this.proChromogenOnlyKitCheck(item.pricedKit.kit)) {
                    body = ChromogenKitForm.serializeChromogenKit(_this.state.chromogenKitFormState);
                }
                else if (item.pricedKit.kit instanceof ManualProKit) {
                    body = ManualProConsumerKitForm.serializeManualProConsumerKit(_this.state.manualProKitFormState);
                }
                else if (item.pricedKit.kit instanceof ManualGoldIfKit) {
                    body = serializeManualGoldIfKit(_this.state.encoderFormState);
                }
                else if (item.pricedKit.kit instanceof AutomatedGoldIfKit) {
                    // TODO
                }
                else {
                    body = serializeSecondaryIfKit(_this.state.secondaryIfFormState);
                }
                postJsonWithAuthn(path, JSON.stringify(body))
                    .then(function (resp) {
                    if (is4xx(resp.status)) {
                        return resp.json().then(function (json) {
                            return new ErrorElements(json.errors);
                        });
                    }
                    return resp.json();
                })
                    .then(function (json) {
                    if (json instanceof ErrorElements) {
                        _this.setState({
                            errors: json.errors,
                            editItemLoading: false
                        }, function () {
                            // TODO so ugly...
                            // pass the errors along to the form
                            _this.setRnaFishFormState(function () { return ({
                                errors: json.errors
                            }); });
                            _this.setSecondaryIfFormState(function () { return ({
                                errors: json.errors
                            }); });
                            _this.setRnaCishFormState(function () { return ({
                                errors: json.errors
                            }); });
                            _this.setChromogenKitFormState(function () { return ({
                                errors: json.errors
                            }); });
                            _this.setManualProFormState(function () { return ({
                                errors: json.errors
                            }); });
                        });
                    }
                    else {
                        _this.props.onCartChange(json);
                        _this.setState({
                            errors: [],
                            editItemLoading: false,
                            editModalOpen: false,
                            editCommentOpen: false,
                            deleteModalOpen: false
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't update kit: " + rej);
                });
            });
        };
        _this.deleteItem = function (item) {
            _this.props.setParentLoadingState(true);
            var path = "/cart/item/id/" + encodeURIComponent(item.id);
            _this.setState({
                editItemLoading: true
            }, function () {
                deleteWithAuthn(path)
                    .then(function (resp) {
                    if (is4xx(resp.status)) {
                        return resp.json().then(function (json) {
                            return new ErrorElements(json.errors);
                        });
                    }
                    return resp.json();
                })
                    .then(function (json) {
                    if (json instanceof ErrorElements) {
                        _this.setState({
                            errors: json.errors
                        }, function () {
                            _this.props.setParentLoadingState(false);
                        });
                    }
                    else {
                        _this.props.onCartChange(json);
                        _this.setState({
                            errors: [],
                            editItemLoading: false,
                            editModalOpen: false,
                            editCommentOpen: false,
                            deleteModalOpen: false
                        });
                        _this.props.setParentLoadingState(false);
                        if (item instanceof ValidCartItem) {
                            _this.setState({
                                deleteModalOpen: false
                            }, function () {
                                gtag('event', 'remove_from_cart', {
                                    value: item.pricedKit.price.subtotalCents / 100.0,
                                    currency: 'USD',
                                    items: [kitPriceToGoogleAnalyticsItems(item.pricedKit.price)]
                                });
                            });
                        }
                        else {
                            // TODO("Handle GTAG Case")
                        }
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't update count: " + rej);
                });
            });
        };
        _this.automatedProKitCheck = function (kit) {
            return kit instanceof AutomatedProKit && (kit.probeSetComponent.length > 0 || kit.detectComponent !== undefined);
        };
        _this.proChromogenOnlyKitCheck = function (kit) {
            return kit instanceof AutomatedProKit && kit.chromogenComponent !== undefined &&
                kit.probeSetComponent.length === 0 && kit.detectComponent === undefined;
        };
        _this.state = {
            editItemLoading: false,
            errors: [],
            editModalOpen: false,
            editCommentOpen: false,
            deleteModalOpen: false,
            rnaFishFormState: props.initialRnaFishEditFormState,
            secondaryIfFormState: props.initialSecondaryIfEditFormState,
            encoderFormState: props.initialManualGoldIfEditFormState,
            rnaCishFormState: props.initialRnaCishFormState,
            chromogenKitFormState: _this.props.initialChromogenKitFormState,
            manualProKitFormState: _this.props.initialManualProFormState
        };
        return _this;
    }
    CartItemView.prototype.render = function () {
        var item = this.props.item;
        return React.createElement(Segment, { key: this.props.offset, className: 'cart-item-card' },
            item instanceof InvalidCartItem &&
                React.createElement(Message, { error: true },
                    "This item is no longer available. Please remove the kit from your cart and contact ",
                    React.createElement("a", { href: "mailto:support@molecularinstruments.com" }, "support@molecularinstruments.com"),
                    " for more information."),
            React.createElement("div", { className: 'cart-item-card-header' },
                React.createElement("div", { className: 'cart-item-card-title' },
                    React.createElement(KitIndexHeader, { itemIndex: this.props.offset, kit: item.kit, adminView: false })),
                React.createElement("div", { className: 'cart-item-card-actions' },
                    item instanceof ValidCartItem && this.quantityStepper(item),
                    item instanceof ValidCartItem && !this.negativeControlProbe(item.pricedKit) && this.editModal(item),
                    this.deleteButton(item))),
            item instanceof ValidCartItem && React.createElement(KitDisplay, { pricedKit: item.pricedKit, displayBlastLink: false, admin: false, quantity: item.quantity, subtotalLabel: "Kit total" }),
            item instanceof InvalidCartItem && React.createElement(KitDisplay, { kit: item.kit, displayBlastLink: false, admin: false, subtotalLabel: "Kit total" }),
            React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        item instanceof ValidCartItem && ORIGIN !== "mi" &&
                            React.createElement("div", { className: 'kit-buttons' }, this.editComment(item)),
                        React.createElement(ErrorDisplay
                        // error display for when deleting/updating fails
                        , { 
                            // error display for when deleting/updating fails
                            errors: this.state.errors, errorPath: "/contents/" + item.id })))));
    };
    return CartItemView;
}(React.PureComponent));
export default CartItemView;
//# sourceMappingURL=CartItemView.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/CartItemView.js
// module id = 1154
// module chunks = 0